/* eslint-disable eqeqeq */
import { Fragment, useEffect, useState } from "react";
import Footer from "../Footer/Footer.js";
import Navigation from "../Navigation/Navigation.js";
import { API_BASE_URL } from "../../api_constants.js";
import axios from "axios";
import $ from "jquery";
import URLS from "../../constants.js";
import ReCAPTCHA from "react-google-recaptcha";
import parse from "html-react-parser";
import { Helmet } from "react-helmet";
import TestiMonialCarousel from "./TestiMonialCarousel.js";



const Internships = () => {
  const [careerList, setInternshipList] = useState([]);
  const [singleInternship, setSingleInternship] = useState({});
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [jobType, setJobType] = useState("");
  const [fileName, setFileName] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");

  const [setUserAuth] = useState(false);

  const circlesData = [
    "Mentorship and guidance from experienced engineers",
    "Exposure to cutting-edge technologies and projects",
    "Opportunity to work on real-world projects",
    "Potential for future fulltime  opportunities",
    "Collaborative and inclusive work environment",
  ];

  useEffect(() => {


    getInternshipList();
  }, []);

  // GET CAREER LIST
  const getInternshipList = () => {
    let URL = URLS.getInternships;
    fetch(URL)
      .then((response) => response.json())
      .then((data) => {
        setInternshipList(data);
      });
  };


  const applyForInternship = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append('full_name', fullName);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("job_type", jobType);
    formData.append("resume", fileName);
    formData.append("job_title", singleInternship.job_title);

    let url = API_BASE_URL + "/web/careers/apply";

    if (fullName == "") {
      alert("Please enter the full name", 3000);
      return;
    } else if (email == "") {
      alert("Please enter the email address", 3000);
      return;
    } else if (phone == "" || phone.length != "10") {
      alert("Please enter the valid Phone number", 3000);
      return;
    } else if (jobType == "") {
      alert("Please enter the job type", 3000);
      return;
    } else if (fileName == "") {
      alert("Please enter the resume.", 3000);
      return;
    } else if (captchaValue === "") {
      alert("Please fill recaptcha.", 3000);
      return;
    }
    // else if (userAuth === false) {
    //   alert("Your are not Human", 3000);
    //   return;
    // }

    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    axios
      .post(url, formData, config)
      .then((response) => {
        console.log('response', response);

        if (response.data.status == '1') {
          alert("Job applied successfully.");
          $("#career-modal").attr({
            style: "display:none",
            "aria-hidden": "true",
          });
          $(".modal-backdrop").css("display", "none");
          $("body").removeClass("modal-open");
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          alert("Please try again..");
        }
      })
      .catch((error) => {
        alert("Please try again..");
      });
  }

  const onChange = (e) => {
    setJobType(e.target.value);
  };

  const handleChangeResume = (event) => {
    // console.log('event',event.target.files[0]);
    // console.log('file name',event.target.files[0].name);
    setFileName(event.target.files[0]);
  };

  // var parse = require('html-react-parser');
  // var des = singleInternship.description && singleInternship.description.replace(/<[^>]+>/g, "")
  // var descrip = parse(des)

  const verifyToken = (value) => {
    // let url = `https://www.google.com/recaptcha/api/siteverify?secret=${process.env.REACT_APP_SECRET_KEY}&response=${value}`;
    // console.log('url',url);
    axios
      .post(
        `https://www.google.com/recaptcha/api/siteverify?secret=${process.env.REACT_APP_SECRET_KEY}&response=${value}`
      )
      .then(
        (response) => {
          console.log('response', response);
          setUserAuth(response.data.success);
        },
        (error) => {
          console.log(error);
        }
      );
  };

  return (
    <Fragment>
      <Helmet>
        <title>Internships at AlgoAnalytics | Explore Opportunities in AI, ML, and Data Science</title>
        <meta
          name='description'
          content='Join AlgoAnalytics and work on cutting-edge AI, ML, and Deep Learning technologies. Explore Internship and internship opportunities in Data Science, Cloud Engineering, and more.'
        />
        <meta
          name='keywords'
          content='Internships in AI, Machine Learning Jobs, Data Scientist Opportunities; Secondary Keywords: Work culture at AlgoAnalytics, Quantum computing roles, Full-stack developer jobs'
        />
      </Helmet>
      <div className='loader'>
        <div className='loader-inner'>
          <img
            src='assets/images/loader.gif'
            alt='Loader GIF'
            className='loader-img'
            loop='infinite'
          />
        </div>
      </div>
      <Navigation />
      {/* <!-- Hero Section Start  --> */}
      <div className='internship-hero-section serv-page-hero padding-top'
        id=''>
        <div className='container '>
          <div className='serv-text text-center mb-5 position-relative mt-2'>
            <h1 style={{ padding: 0, margin: 0 }}>Start Your Journey With Us!</h1>
            <br></br>
            <h4>Join our internship Program: Real-World Experience in Technology, Analytics, and Innovation</h4>
          </div>
          <img
            src='assets/images/group-image.png'
            alt='img'
            className='img-interns-group'
          />
          
        </div>
      </div>
      {/* <!-- Hero Section End  --> */}
      {/* <!-- Opportunity Section Start  --> */}
      <div  style={{ marginTop: '40px' }} className='internship-opportunity-section serv-page-hero '>
      <div className='container '>
        <div className='serv-text text-center mb-5 position-relative mt-2'>
          <h1 style={{ padding: 0, margin: 0 }}>Discover Our Internship Opportunities</h1>
          <br></br>
          <h4>Kickstart Your Internship with Advanced Analytics and AI Innovations</h4>
        </div>
        <img
          src='assets/images/AlgoAnalyticsCarrerLogo.png'
          alt='img'
          className='img-interns-group'
        />
        <div className='serv-text text-center mb-5 position-relative mt-2'>
          <h4>At AlgoAnalytics, kickstart your Internship by working on transformative <br />projects in advanced analytics, cutting-edge algorithms,<br /> and groundbreaking AI solutions, shaping the future of technology and innovation.
          </h4>
        </div>
        
        </div>
      </div>
      {/* <!-- Opportunity Section End  --> */}
      {/* <!-- Main Section Start  --> */}
      
      {/* <!-- Main Section End  --> */}


      {/* <!-- Offer Section Start  --> */}
      <div className='internship-offer-section serv-page-hero'
        id=''>
           <div className='container '>
        <div className='serv-text text-center mb-5 position-relative mt-2'>
          <h1 style={{ padding: 0, margin: 0 }}>What Do We Offer</h1>
          <br></br>
        </div>
        <div className="circle-container">
          {circlesData.map((text, index) => (
            <div key={index} className="circle" style={{ fontSize: '14px' }}>
              <span style={{ fontSize: '14px' }}>{text}</span>
            </div>
          ))}
        </div>
        </div>
      </div>
      {/* <!-- Offer Section End  --> */}
      {/* <!-- Path Section Start  --> */}
      <div className='internship-path-container' style={{ margin: '100px' }} id="findAtalgo">
        <div className='serv-text text-center'>
          <h1 style={{ padding: 0, margin: 0 }}>Your Path to Innovation and Growth</h1>
        </div>

        <div className='container '>
          <div className='row text-center'>
            <div className='col-lg-2 col-md-12'></div>
            <div className='col-lg-9 col-md-12'>
              <div className='find-sec-bottom'>
                <div className='t-text'>
                  {" "}
                  <img
                    src='assets/images/tick.png'
                    alt='img'
                    className='img-fluid'
                  />
                  <span style={{ fontWeight: '700', fontSize: '25px' }}>CEO Recommendation</span>
                </div>
                <div className='t-text'>
                  <span style={{ marginLeft: '50px', fontSize: '20px', textAlign: 'left' }}>Exceptional interns may receive a personal recommendation from our CEO, highlighting their outstanding performance and dedication.</span>
                </div>
                <div className='t-text-block'></div>
                <div className='t-text'>
                  {" "}
                  <img
                    src='assets/images/tick.png'
                    alt='img'
                    className='img-fluid'
                  />
                  <span style={{ fontWeight: '700', fontSize: '25px' }}>Shaping the Future </span>
                </div>
                <div className='t-text'>
                  <span style={{ marginLeft: '50px', fontSize: '20px', textAlign: 'left' }}>Build a strong foundation for full-time roles or future internships in analytics and AI.</span>
                </div>
                <div className='t-text-block'></div>
                <div className='t-text'>
                  {" "}
                  <img
                    src='assets/images/tick.png'
                    alt='img'
                    className='img-fluid'
                  />
                  <span style={{ fontWeight: '700', fontSize: '25px' }}>Driving Change in AI</span>
                </div>
                <div className='t-text'>
                  <span style={{ marginLeft: '50px', fontSize: '20px', textAlign: 'left' }}>Engage in algorithm development and data-driven projects with industry innovators.</span>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      {/* <!-- Path Section End  --> */}
      <div>
          <h3 style={{ textAlign: "center", marginTop: "80px", color: "#007bff", marginBottom: '80px' }}> <u>For Internship opportunities kindly share your resume on  <b>info@algoanalytics.com</b> </u></h3>
        </div>

      {/* <!-- Corousal Section Start  --> */}
      <div className='internship-courousal-section' style={{marginBottom: '100px'}}>
      <div className='container '>
        <div className='serv-text text-center mb-5 position-relative mt-2 Internship-page-main-heading'>
          <h1 style={{ padding: 0, margin: 0 }}>Internship Testimonial</h1>
          <h4>See what our Interns say about us</h4>
        </div>
        <TestiMonialCarousel />
        </div>
      </div>
      {/* <!-- Corousal Section End  --> */}
      {/* <!-- Certification Section Start  --> */}
      
      {/* <!-- Certification Section End  --> */}

          


      <Footer />
      {/* <!--bottom button--> */}
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a className='back-top' href='#'>
        <i className='fa fa-angle-up'></i>
      </a>
      {/* <!--career modal--> */}
      <div
        className='modal career-modal'
        id='career-modal'
        data-keyboard='false'
        data-backdrop='static'>
        <div className='modal-dialog'>
          <div
            className='modal-content'
            style={{ position: "absolute", top: 0 }}>
            {/* <!-- Modal Header --> */}
            <div className='modal-header'>
              <h4 className='modal-title'>
                {singleInternship.job_title && singleInternship.job_title.replace(".","")}
              </h4>
              <button type='button' className='close' data-dismiss='modal'>
                <svg
                  width='28'
                  height='28'
                  viewBox='0 0 28 28'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M13.9968 10.9664L8.65832 5.62818C7.8236 4.79061 6.46861 4.79061 5.62818 5.62818C4.79061 6.46576 4.79061 7.82074 5.62818 8.65831L10.9666 13.9965L5.6339 19.3327C4.79632 20.1703 4.79632 21.5252 5.6339 22.3628C6.05126 22.783 6.60011 22.9917 7.14897 22.9917C7.69782 22.9917 8.24667 22.783 8.66403 22.3628L13.9968 17.0266L19.3381 22.3711C19.7555 22.7913 20.3043 23 20.8532 23C21.3992 23 21.9509 22.7913 22.3682 22.3711C23.2058 21.5335 23.2058 20.1785 22.3682 19.341L17.0269 13.9965L22.3625 8.66432C23.2001 7.82674 23.2001 6.47176 22.3625 5.63418C21.525 4.79661 20.17 4.79661 19.3324 5.63418L13.9968 10.9664Z'
                    fill='#86909F'
                  />
                </svg>
              </button>
            </div>

            {/* <!-- Modal body --> */}
            <div className='modal-body'>
              <div className='career-modal-container'>
                <div className='career-modal-inner text-left'>
                  <div className='job-info'>
                    <h4>About the role</h4>
                    <p>
                      {parse(String(singleInternship.responsibilities))}
                      {/* {des} */}
                      {/* </div> */}
                    </p>
                  </div>
                  <div className='job-info'>
                    <h4>Prerequisites</h4>
                    <ul className='job-list'>
                      <li>
                        {parse(String(singleInternship.prerequisite))}
                      </li>
                    </ul>
                  </div>
                  <div className='job-btn mt-4'>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a className='btn-all btn-light-blue mx-auto'>Apply</a>
                  </div>
                </div>
                <div className='career-form-content'>
                  <form className='career-form'>
                    <div className='form-top'>
                      <h4 className='form-title text-left'>
                        Enter Details: <span>*</span>
                      </h4>
                      <div className='c-form-input'>
                        <input
                          type='text'
                          className='f-input'
                          placeholder='Full Name'
                          value={fullName}
                          onChange={(e) => setFullName(e.target.value)}
                        />
                      </div>
                      <div className='c-form-input'>
                        <input
                          type='text'
                          className='f-input'
                          placeholder='Email Address'
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <div className='c-form-input'>
                        <input
                          type='text'
                          className='f-input'
                          placeholder='Phone Number'
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className='form-top'>
                      <h4 className='form-title text-left'>Select Type:</h4>
                      <div className='c-form-input'>
                        <div className='f-radio d-flex align-items-center'>
                          <div className='mr-4'>
                            <input
                              type='radio'
                              id='test1'
                              name='jobType'
                              value='full-time'
                              checked={jobType == "full-time" ? true : false}
                              onChange={onChange}
                            />
                            <label for='test1'>Full-time Opportunity</label>
                          </div>
                          <div className=''>
                            <input
                              type='radio'
                              id='test2'
                              name='jobType'
                              value='internship'
                              onChange={onChange}
                              checked={jobType == "internship" ? true : false}
                            />
                            <label for='test2'>Internship Opportunity</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='form-top'>
                      <div className='upload-inputs'>
                        <div>
                          <h4 className='form-title text-left'>
                            Upload Resume:<span>*</span>
                          </h4>
                          <div className='d-flex mr-auto'>
                            <input
                              type='file'
                              style={{ display: "block" }}
                              onChange={handleChangeResume}
                            />
                          </div>
                        </div>
                        <div className="rcaptcha">
                          <ReCAPTCHA
                            sitekey='6LdCP4EeAAAAAH_QbmAxLPUPtaob9gGHmyPQ2XRd'
                            onChange={(value) => {
                              verifyToken(value);
                              setCaptchaValue(value);
                            }}
                          // size='invisible'
                          />
                        </div>
                      </div>
                      <div className='submit-btn mt-5'>
                        <button
                          type='submit'
                          onClick={applyForInternship}
                          className='btn-small btn-light-blue mx-auto '>
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};


export default Internships;
